import React from "react";
import { FormattedMessage } from "react-intl";
import "./banner.scss";
import { AiFillPlayCircle } from "react-icons/ai";
import { bannerData } from "../data";
import { Link } from "react-router-dom";
import StyledLink from "../../../shared/StyledLink/StyledLink";

const Banner = () => {
  return (
    <div className="signup-banner">
      <div className="text">
        <h1 className="big-title">
          <FormattedMessage
            id="signup-banner-title"
            defaultMessage="Join AdGate now"
          />
        </h1>
        <p className="def-text">
          <FormattedMessage
            id="signup-banner-text"
            defaultMessage="Sign up as:"
          />
        </p>
      </div>

      <div className="row">
        {bannerData.map((props, i) => {
          return (
            <div className={`bannerCard ${props.className}`} key={i}>
              <div
                className="line"
                style={{ backgroundColor: `${props.color}` }}
              ></div>

              <h1 className="mid-title">{props.title}</h1>
              <p className="def-text">{props.text}</p>
              <StyledLink
                to={props.to}
                styles={props.styles}
                linkName={
                  <FormattedMessage
                    id="signup-card-link"
                    defaultMessage="Get Started"
                  />
                }
              />
            </div>
          );
        })}
      </div>

      <div className="triangle triangle1" />
      <div className="triangle triangle2" />
    </div>
  );
};

export default Banner;
